<template>
  <div class="card-info">
    <div class="header-card">
      <h1 class="general-title">General</h1>
      <font-awesome-icon
        class="icon-title general-title"
        icon="times"
        @click="close"
      />
    </div>
    <div class="body-card">
      <table>
        <tr class="general-title">
          <td><p>Project Name</p></td>
        </tr>
        <tr class="text">
          <td>
            <p>
              Design and operation for hydraulic fracturing, Well PE32 –
              Technical support
            </p>
          </td>
        </tr>
      </table>
      <div class="tr-flex">
        <div class="td-flex">
          <span class="general-title">Company</span>
          <span class="text">Pampa Energy</span>
          <span class="general-title">Block</span>
          <span class="text">B</span>
        </div>
        <div class="td-flex">
          <span class="general-title">Country</span>
          <span class="text">Argentina</span>
          <span class="general-title">Field</span>
          <span class="text">Medanito</span>
        </div>
        <div class="td-flex">
          <span class="general-title">Basin</span>
          <span class="text">Neuquina</span>
          <span class="general-title">Date</span>
          <span class="text">Jan 14, 2021</span>
        </div>
      </div>

      <table>
        <tr class="general-title">
          <td><p>Objective</p></td>
        </tr>
        <tr class="text">
          <td>
            <p>
              Provide technical support during design and execution for
              hydraulic fracturing of Well PE32
            </p>
          </td>
        </tr>
      </table>
      <table>
        <tr class="general-title">
          <td><p>Scope</p></td>
        </tr>
        <tr class="text">
          <td>
            <p>
              Provide technical support during all processes that involve the
              successful execution of the hydraulic fracturing of well PE32,
              from the technical and economic evaluation of the design (done
              in-house and by service companies), selection of the service
              company, operational plan evaluation, operation execution and
              analysis of results.
            </p>
          </td>
        </tr>
      </table>
      <table>
        <tr class="general-title">
          <td>
            <p>Estimated Project execution time: 160 Hours – Time line below</p>
          </td>
        </tr>
        <tr class="text">
          <td>
            <div class="indicator">
              <div class="back"></div>
              <div class="load"></div>
            </div>
            <div class="dates-indicator text">
              <p>Jan, 10 2021</p>
              <p>Apr, 30, 2021</p>
            </div>
          </td>
        </tr>
      </table>
      <div class="tr-flex">
        <div class="td-flex">
          <span class="general-title">Representative for client</span>
          <span class="text">Carlos Alberto Rodríguez</span>
        </div>
        <div class="td-flex">
          <span class="general-title">Email</span>
          <span class="text email">carlos.rodriguez@pampaenergy.au</span>
        </div>
      </div>
      <table>
        <tr>
          <td><span class="general-title">Telephone</span></td>
        </tr>
        <tr>
          <td><span class="text">+54 9 1131771755</span></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    close() {
      this.$emit("close", "General");
    },
  },
};
</script>

<style>
.card-info {
  padding: 13px 15px;
  border-radius: 10px;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.2);

  background: white;
}
table {
  width: 100%;
}
.tr-flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.td-flex {
  display: flex;
  flex-direction: column;
}
p {
  margin: 0;
}
.general-title {
  color: var(--sixth-color);
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}
.general-title p {
  margin: 0;
}
.text {
  color: #000;
  font-family: "Poppins", sans-serif;
  font-weight: 400;
}
.card-info .header-card {
  position: relative;
  widows: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-info .header-card .icon-title {
  position: absolute;
  right: 5px;
  top: 5px;
}
.card-info .header-card h1 {
  font-size: 1.8rem;
  margin: 0;
  text-align: center;
}

.dates-indicator {
  display: flex;
  justify-content: space-between;
}
.indicator {
  position: relative;
  width: 100%;
  height: 15px;
}
.indicator div {
  position: absolute;
  height: 10px;
}
.indicator .back {
  width: 100%;
  background: var(--third-color);
}
.indicator .load {
  width: 90%;
  background: var(--firts-color);
}
.card-info .body-card h2 {
  margin-bottom: 0;
}
/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/

@media (max-width: 991px) and (min-width: 768px) {
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/

@media (max-width: 767px) {
  .tr-flex {
    flex-direction: column;
    justify-content: start;
    align-items: initial;
  }
  .email {
    font-size: 0.8rem;
  }
}
</style>